import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobEditCoursesPage from '@/features/jobs/job-edit-courses/JobEditCoursesPage';

export const jobEditCoursesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/editar/formacao/cursos',
  component: JobEditCoursesPage,
});
